import { render, staticRenderFns } from "./ShowBase.vue?vue&type=template&id=1c4e0cd3"
import script from "./ShowBase.vue?vue&type=script&lang=js"
export * from "./ShowBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports